import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from '../../assets/config/config-svc.service';
import { SharedService } from '../shared/shared.service';
import { ClassOfServiceTo } from '../shared/models/classOfServiceTo';

@Injectable({
    providedIn: 'root'
})
export class ClassOfServiceService {

    constructor(private http: HttpClient, private sharedService: SharedService) {
    }

    getHeaders() {
        return this.getHeadersForContent('application/json', 'json');
    }

    getHeadersForContent(contentType, responseType) {
        const httpOptions = {
            headers: new HttpHeaders({
                'transactionId': this.sharedService.generateUUID(),
                'reportType': 'All'
            }),
            withCredentials: true,
            responseType: responseType
        };
        if (contentType) {
            httpOptions.headers.append('ContentType', contentType);
        }
        return httpOptions;
    }

    public createClassOfService(payload: any): Observable<ClassOfServiceTo> {
        return this.http.post(ConfigService.config.brokerServiceUrl + '/class-of-service/create', payload, this.getHeaders())
            .pipe(map((res: any) => new ClassOfServiceTo(res)));
    }

    public updateClassOfService(payload: any): Observable<ClassOfServiceTo> {
        return this.http.put(ConfigService.config.brokerServiceUrl + '/class-of-service/update', payload, this.getHeaders())
            .pipe(map((res: any) => new ClassOfServiceTo(res)));
    }

    public getClassOfService(orgId?: string): Observable<ClassOfServiceTo> {
        const url = ConfigService.config.brokerServiceUrl + '/class-of-service/read'
            + (orgId ? '?orgId=' + encodeURIComponent(orgId) : '?global=true');
        return this.http.get(url, this.getHeaders())
            .pipe(map((res: any) => new ClassOfServiceTo(res)));
    }

    public deleteClassOfService(orgId?: string): Observable<void> {
        const url = ConfigService.config.brokerServiceUrl + '/class-of-service/delete'
            + (orgId ? '?orgId=' + encodeURIComponent(orgId) : '?global=true');
        return this.http.delete(url, this.getHeaders()).pipe(map((res: any) => res));
    }
}
